import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import {
  IContactFormData,
  type IContactDetails,
} from '@principle-theorem/principle-core/interfaces';
import { ContactFormComponent } from '../contact-form/contact-form.component';

@Component({
  selector: 'pr-contact-form-dialog',
  imports: [CommonModule, NgDialogModule, ContactFormComponent],
  templateUrl: './contact-form-dialog.component.html',
  styleUrls: ['./contact-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactFormDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IContactFormData,
    private _dialogRef: MatDialogRef<ContactFormDialogComponent>
  ) {}

  submit(data: Partial<IContactDetails>): void {
    this._dialogRef.close(data);
  }
}
